import request from "../../graphql/request";
import {
  FETCH_FIRMS,
  CREATE_FIRM,
  FETCH_FIRM_FOR_EDIT,
  UPDATE_FIRM_FOR_EDIT,
  CHECK_FIRM_NAME_EXISTS,
} from "./queries";

export const fetchFirms = variables =>
  request({
    query: FETCH_FIRMS,
    variables: variables,
  });

export const createFirmService = (firmData) =>
  request({
    query: CREATE_FIRM,
    variables: firmData,
  });

export const fetchFirmForEditService = variables =>
  request({
    query: FETCH_FIRM_FOR_EDIT,
    variables,
  });

export const updateFirmForEditService = firmData =>
  request({
    query: UPDATE_FIRM_FOR_EDIT,
    variables: firmData,
  });

export const checkFirmNameExistsService = variables =>
  request({
    query: CHECK_FIRM_NAME_EXISTS,
    variables,
  });
